var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapActions } from 'vuex';
import { Const } from './provider/candle-history/lib/const.cls';
import * as Types from '../../types';
import { fxView } from './lib/fxView.cls';
import * as fxViewStoreExtensions from './provider/candle-history';
var state = __assign({}, fxViewStoreExtensions.stateExt);
var actions = __assign({}, fxViewStoreExtensions.actionsExt);
var mutations = __assign({}, fxViewStoreExtensions.mutationsExt);
var getters = __assign({}, fxViewStoreExtensions.gettersExt);
var fireabase_messaging;
var fireabase_SW = "";
var fxViewStore = {
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
};
var _store;
var intervalValue = null;
export var fxViewMixins = {
    created: function () {
        var _store = this.$store;
        if (!(_store && _store.state && _store.state[fxView.STORE_MODULE_NAME])) {
            this.$store.registerModule(fxView.STORE_MODULE_NAME, fxViewStore);
        }
        // this.intializeFirebase()
    },
    methods: __assign({}, mapActions({
        _runSaveuserToken: Types.SAVE_FIREBASE_TOKEN,
        _runLanguageApi: Const.RUN_LANGUAGE_API,
        //=======================trading-tools=============================================
        _runGetAutochartistData: Const.RUN_GET_AUTOCHARTIST_DATA,
        _runGetSignalCentreData: Const.RUN_GET_SIGNAL_CENTRE_DATA,
        _runGetCurrentNews: Const.RUN_GET_CURRENT_NEWS,
        _runGetCurrentNewsDetails: Const.RUN_GET_CURRENT_NEWS_DETAIL,
        _runGetEconomicCalData: Const.RUN_GET_ECONOMIC_CALENDER_DATA,
        _runCouponPlan: Const.RUN_COUPON_PLAN,
        _runGetCouponList: Const.RUN_GET_COUPON_LIST,
        _runCheckCouponValidity: Const.RUN_CHECK_COUPON_VALIDITY,
        _runGetVpsList: Const.RUN_GET_VPS_LIST,
        _runGetVpsDetail: Const.RUN_GET_VPS_DETAIL,
        _runVpsRestart: Const.RUN_VPS_RESTART,
        _runVpsReboot: Const.RUN_VPS_REBOOT,
        _runVpsShutdown: Const.RUN_VPS_SHUTDOWN,
        _runVpsChangePassword: Const.RUN_VPS_CHANGE_PASSWORD,
        _runGetSubPlanList: Const.RUN_GET_SUB_PLAN_LIST,
        _runGetSubPlanDetail: Const.RUN_GET_SUB_PLAN_DETAIL,
        _runSubOperLink: Const.RUN_SUB_OPERATION_LINK,
        _runSubOperation: Const.RUN_SUB_OPERATION,
        _runCreateSubTicket: Const.RUN_CREATE_SUB_TICKET,
        _runUnsubService: Const.RUN_UNSUB_SERVICE,
        //=========================user=====================================================
        _runGetUserProfile: Const.RUN_GET_USER_PROFILE,
        _runUserNotification: Const.RUN_USER_NOTIFICATIONS,
        _runGetUserRegisterationStepData: Const.RUN_GET_USER_REGISTERATION_STEP_DATA,
        //========================trading accounts==========================================
        _runCreateAccount: Const.RUN_CREATE_ACCOUNT,
        _runGetAccountHistory: Const.RUN_GET_ACCOUNT_HISTORY,
        _runCreateApiSubscription: Const.RUN_CREATE_API_SUBSCRIPTION,
        _runGetTradingAccountList: Const.RUN_GET_TRADING_ACCOUNT_LIST,
        _runAddLastSelectTradingAccount: Const.RUN_ADD_LAST_SELECT_TRADING_ACCOUNT,
        _runGetAccountDetails: Const.RUN_GET_TRADING_ACCOUNT_DETAILS,
        _runGetAccountPriorityList: Const.RUN_GET_ACCOUNT_PRIORITY_LIST,
        //========================manage accounts==========================================
        _runAccountPasswordRequestOtp: Const.RUN_ACCOUNT_PASSWORD_REQUEST_OTP,
        _runAccountPasswordCheckOtp: Const.RUN_ACCOUNT_PASSWORD_CHECK_OTP,
        _runAccountLeverageCheckOtp: Const.RUN_ACCOUNT_LEVERAGE_CHECK_OTP,
        _runInternalTransferCheckOtp: Const.RUN_INTERNAL_TRANSFER_CHECK_OTP,
        _runResendEmailLinkAccount: Const.RUN_RESEND_EMAIL_LINK_ACCOUNTS,
        _runAmountConversionApi: Const.RUN_AMOUNT_CONVERSION_API,
        //======================support=======================================================
        _runGetTicketList: Const.RUN_GET_TICKET_LIST,
        _runGetTicketDetail: Const.RUN_GET_TICKET_DETAIL,
        _runTicketRequestOtp: Const.RUN_TICKET_REQUEST_OTP,
        _runTicketCheckOtp: Const.RUN_TICKET_CHECK_OTP,
        _runTicketReply: Const.RUN_TICKET_REPLY,
        _runGetTicketReasonList: Const.RUN_GET_TICKET_REASON_LIST,
        _runTicketResendOtp: Const.RUN_TICKET_RESEND_OTP,
        //==================================deposit=========================================
        _runGetDepositList: Const.RUN_GET_DEPOSIT_LIST,
        _runTransactionLimitCurrency: Const.RUN_TRANS_LIMIT_CURRENCY,
        _runDemoDeposit: Const.RUN_DEMO_DEPOSIT,
        _runGetUserCanDeposit: Const.RUN_GET_USER_CAN_DEPOSIT,
        _runCreditCardDeposit: Const.RUN_CREDIT_CARD_DEPOSIT,
        _runGetTransactionStatus: Const.RUN_GET_TRANSACTION_STATUS,
        //==================================bank=========================================
        _runAddBank: Const.RUN_ADD_BANK,
        _runGetBankList: Const.RUN_GET_BANK_LIST,
        //==================================withdrawal========================================
        _runGetWithdrawalList: Const.RUN_GET_WITHDRAWAL_LIST,
        _runWithdrawalRequestOtp: Const.RUN_WITHDRAWAL_REQUEST_OTP,
        _runWithdrawalCheckOtp: Const.RUN_WITHDRAWAL_CHECK_OTP,
        _runResendEmailLink: Const.RUN_RESEND_EMAIL_LINK,
        _runGetWithdrawalMethods: Const.RUN_GET_WITHDRAWAL_METHODS,
        _runGetWithdrawalDesc: Const.RUN_GET_WITHDRAWAL_DESC,
        //=============================bonus===================================================
        _runTradingBonus: Const.RUN_TRADING_BONUS,
        _runBonusRequestOtp: Const.RUN_BONUS_REQUEST_OTP,
        _runBonusCheckOtp: Const.RUN_BONUS_CHECK_OTP,
        _runResendEmailLinkBonus: Const.RUN_RESEND_EMAIL_LINK_BONUS,
        _runGetBonusList: Const.RUN_GET_BONUS_LIST,
        _runRemoveBonus: Const.RUN_REMOVE_BONUS,
        //===================static variable fetch from database============================
        _runGetCountriesList: Const.RUN_GET_COUNTRIES_LIST,
        _runGetCitiesList: Const.RUN_GET_CITIES_LIST,
        //===================Dashboard charts===============================================
        _runGetProfitData: Const.RUN_GET_PROFIT_CHART_DATA,
        _runGetBalanceData: Const.RUN_GET_BALANCE_DATA,
        _runGetEquityData: Const.RUN_GET_EQUITY_DATA,
        _runGetTradingData: Const.RUN_GET_TRADING_DATA,
        _runGetIdenfyToken: Const.RUN_GET_IDENFY_TOKEN,
        _runSubmitConsent: Const.RUN_SUBMIT_CONSENT,
        _runGetHoopsData: Const.RUN_GET_HOOPS_DATA,
        _runGetTutCourseCategory: Const.RUN_GET_TUT_COURSE_CATEGORY,
        _runGetVideoTutorial: Const.RUN_GET_VIDEO_TUTORIAL,
        _runUpdateFirstDeposit: Const.RUN_UPDATE_FIRST_DEPOSIT,
        //cancel withdrawal request====================
        _runCancelWithdrawalRequest: Const.RUN_CANCEL_WITHDRAWAL_REQUEST,
        //==============================NUVEI Request =========================================
        _runNuveiRequest: Const.RUN_NUVEI_REQUEST,
    }), { handleValidationErrorAdvanced: function (getErrors) {
            console.log(getErrors.collect());
            var firstField = Object.keys(getErrors.collect())[0];
            console.log(firstField + "Input", this.$refs[firstField + "Input"]);
            try {
                if (Array.isArray(this.$refs[firstField + "Input"])) {
                    this.$refs[firstField + "Input"][0].focus();
                    return this.$refs[firstField + "Input"][0].scrollIntoView();
                }
                else {
                    this.$refs[firstField + "Input"].focus();
                    return this.$refs[firstField + "Input"].scrollIntoView();
                }
            }
            catch (e) {
                console.log(e);
            }
        }, numberWithCommas: function (x) {
            if (x == undefined) {
                x = 0;
            }
            var negative = "";
            if (x < 0) {
                negative = '-';
            }
            x = parseFloat(x).toFixed(2);
            x = Math.abs(x);
            x = x.toString();
            var afterPoint = '';
            if (x.indexOf('.') > 0)
                afterPoint = x.substring(x.indexOf('.'), x.length);
            x = Math.floor(x);
            x = x.toString();
            var lastThree = x.substring(x.length - 3);
            var otherNumbers = x.substring(0, x.length - 3);
            if (otherNumbers != '')
                lastThree = ',' + lastThree;
            return negative + otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
        }, computedCommonFunc: function (getFuncName) {
            try {
                return this.$store.getters[getFuncName];
            }
            catch (ex) {
                return [];
            }
        },
        serviceFunction: function (planId, detailId, clickEvent) {
            var sub_array = this.get_user.profile.subscriptions, count = 0, id;
            if (detailId != '' && detailId != null) {
                if (sub_array.length > 0) {
                    for (var i = 0; i <= sub_array.length - 1; i++) {
                        if ((parseInt(sub_array[i].plan_id) == parseInt(planId)) && (parseInt(sub_array[i].pdetail_id) == parseInt(detailId))) {
                            count = 1;
                            if (clickEvent != '' && clickEvent != null && clickEvent != undefined) {
                                id = sub_array[i].id;
                            }
                        }
                        if (i == sub_array.length - 1) {
                            if (count == 1) {
                                if (clickEvent != '' && clickEvent != null && clickEvent != undefined) {
                                    this.unsubscribe1(id);
                                }
                                return true;
                            }
                            else {
                                return false;
                            }
                        }
                    }
                }
                else {
                    return false;
                }
            }
            else {
                if (sub_array.length > 0) {
                    var count1 = 0;
                    for (var j = 0; j <= sub_array.length - 1; j++) {
                        if (parseInt(sub_array[j].plan_id) == parseInt(planId)) {
                            count1 = 1;
                        }
                        if (j == sub_array.length - 1) {
                            if (count1 == 1) {
                                return false;
                            }
                            else {
                                return true;
                            }
                        }
                    }
                }
                else {
                    return true;
                }
            }
        },
        reaskPermission: function () {
            var permission;
            if ('Notification' in window) {
                permission = Notification.permission;
                return permission;
                // if (permission == 'denied') {
                //    	//show him to enable code 	
                // }
            }
            else {
                return false;
            }
        } }),
    computed: {
        //trading-tool
        jurisdiction_tax_residence_list: function () { return this.computedCommonFunc(Const.GET_JURISDICTION_TAX_RESIDENCE); },
        signalCentre: function () { return this.computedCommonFunc(Const.GET_SIGNAL_CENTRE); },
        european_countries_list: function () { return this.computedCommonFunc(Const.GET_EUROPEAN_COUNTRY_LIST); },
        autoChartist: function () { return this.computedCommonFunc(Const.GET_AUTO_CHARTIST); },
        currentNews: function () { return this.computedCommonFunc(Const.GET_CURRENT_NEWS); },
        newsDetail: function () { return this.computedCommonFunc(Const.GET_CURRENT_NEWS_DETAIL); },
        economicCalData: function () { return this.computedCommonFunc(Const.GET_ECONOMIC_CALENDER_DATA); },
        subPlanList: function () { return this.computedCommonFunc(Const.GET_SUB_PLAN_LIST); },
        subPlanDetail: function () { return this.computedCommonFunc(Const.GET_SUB_PLAN_DETAIL); },
        vpsList: function () { return this.computedCommonFunc(Const.GET_VPS_LIST); },
        vpsDetail: function () { return this.computedCommonFunc(Const.GET_VPS_DETAIL); },
        //user
        get_user: function () { return this.computedCommonFunc(Types.GET_USER); },
        getUserProfile: function () { return this.computedCommonFunc(Const.GET_USER_PROFILE); },
        country_tax_residence_nationality: function () { return this.computedCommonFunc(Const.GET_COUNTRY_TAX_RESIDENCE_NATIONALITY); },
        userNotify: function () { return this.computedCommonFunc(Const.GET_USER_NOTIFICATIONS); },
        countriesList: function () { return this.computedCommonFunc(Const.GET_COUNTRIES_LIST); },
        citiesList: function () { return this.computedCommonFunc(Const.GET_CITIES_LIST); },
        empStatus: function () { return this.computedCommonFunc(Const.GET_EMP_STATUS); },
        acOpeningReason: function () { return this.computedCommonFunc(Const.GET_AC_OPENING_REASON); },
        sourceOfFunds: function () { return this.computedCommonFunc(Const.GET_SOURCE_OF_FUNDS); },
        natureOfTransaction: function () { return this.computedCommonFunc(Const.GET_NATURE_OF_TRANSACTION); },
        originOfFunds: function () { return this.computedCommonFunc(Const.GET_ORIGIN_OF_FUNDS); },
        occupationList: function () { return this.computedCommonFunc(Const.GET_OCCUPATION); },
        educationList: function () { return this.computedCommonFunc(Const.GET_EDUCATION); },
        employmentList: function () { return this.computedCommonFunc(Const.GET_EMPLOYMENT); },
        genderList: function () { return this.computedCommonFunc(Const.GET_GENDER_LIST); },
        isTradingExperience: function () { return this.computedCommonFunc(Const.GET_IS_TRADING_EXPERIENCE); },
        estYearlyIncome: function () { return this.computedCommonFunc(Const.GET_EST_YEARLY_INCOME); },
        estNetWorth: function () { return this.computedCommonFunc(Const.GET_EST_NET_WORTH); },
        netDisposableIncome: function () { return this.computedCommonFunc(Const.GET_NET_DISPOSABLE_INCOME); },
        investedTradingAmount: function () { return this.computedCommonFunc(Const.GET_INVESTED_TRADING_AMOUNT); },
        tradingTurnover: function () { return this.computedCommonFunc(Const.GET_TRADING_TURNOVER); },
        antAccountTurnover: function () { return this.computedCommonFunc(Const.GET_ANT_ACCOUNT_TURNOVER); },
        docsLink: function () { return this.computedCommonFunc(Const.GET_DOCS_LINK); },
        tinsynom: function () { return this.computedCommonFunc(Const.GET_TIN_PASSPORT_OPTION); },
        couponList: function () { return this.computedCommonFunc(Const.GET_COUPON_LIST); },
        //CRS & MiFir
        // tinsynom : function(){ return this.computedCommonFunc(Const.CRSNUMBER); },
        //trading accounts
        lastSelectTradingAccount: function () { return this.computedCommonFunc(Const.GET_LAST_SELECT_TRADING_ACCOUNT); },
        tradingAccountList: function () { return this.computedCommonFunc(Const.GET_TRADING_ACCOUNT_LIST); },
        liveAccountList: function () { return this.computedCommonFunc(Const.GET_LIVE_ACCOUNT_LIST); },
        demoAccountList: function () { return this.computedCommonFunc(Const.GET_DEMO_ACCOUNT_LIST); },
        accountDetails: function () { return this.computedCommonFunc(Const.GET_ACCOUNT_DETAILS); },
        currency: function () { return this.computedCommonFunc(Const.GET_CURRENCY); },
        //deposit
        depositList: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_LIST); },
        deposit_limit: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_LIMIT); },
        paymentStatus: function () { return this.computedCommonFunc(Const.GET_PAYMENT_STATUS); },
        depositMethod: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_METHOD); },
        depositType: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_TYPE); },
        depositBankListDetail: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_BANK_LIST); },
        //withdrawal
        withdrawalList: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_LIST); },
        withdrawalType: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_TYPE); },
        withdrawalMethodResponse: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_METHOD_RESPONSE); },
        withdrawalMethodResponseDep: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_METHOD_RESPONSE_DEP); },
        withdrawalMethod: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_METHOD); },
        withdrawalStatus: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_STATUS); },
        //bonus
        bonusList: function () { return this.computedCommonFunc(Const.GET_BONUS_LIST); },
        bonusType: function () { return this.computedCommonFunc(Const.GET_BONUS_TYPE); },
        //support
        ticketData: function () { return this.computedCommonFunc(Const.GET_TICKET_DATA); },
        ticketList: function () { return this.computedCommonFunc(Const.GET_TICKET_LIST); },
        ticketView: function () { return this.computedCommonFunc(Const.GET_TICKET_VIEW); },
        ticketReasonList: function () { return this.computedCommonFunc(Const.GET_TICKET_REASON_LIST); },
        reasonList: function () { return this.computedCommonFunc(Const.GET_REASON_LIST); },
        //bank
        bankListData: function () { return this.computedCommonFunc(Const.GET_BANK_LIST); },
        depositLink: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_LINK); },
        imageLinkPortfolio: function () { return this.computedCommonFunc(Const.GET_IMAGE_LINK_PORTFOLIO); },
        //static
        legalDocLink: function () { return this.computedCommonFunc(Const.GET_LEGAL_DOC_LINK); },
        privacyPolicyLink: function () { return this.computedCommonFunc(Const.GET_PRIVACY_POLICY_LINK); },
        ClientAgreement: function () { return this.computedCommonFunc(Const.GET_CLIENT_AGREEMENT_LINK); },
        IdentificationProcedure: function () { return this.computedCommonFunc(Const.GET_IDEN_PROCEDURE_LINK); },
        OrderExecutionPolicy: function () { return this.computedCommonFunc(Const.GET_ORDEREXE_POLICY_LINK); },
        ConflictofInterest: function () { return this.computedCommonFunc(Const.GET_CONFLICT_INTEREST_LINK); },
        ClientCategorisation: function () { return this.computedCommonFunc(Const.GET_CLIENT_CATEGORISATION_LINK); },
        InvestorCompensation: function () { return this.computedCommonFunc(Const.GET_INVESTOR_COMPENSATION_LINK); },
        leverageJson: function () { return this.computedCommonFunc(Const.GET_LEVERAGE_JSON); },
        leverageJsonPLCountry: function () { return this.computedCommonFunc(Const.GET_LEVERAGE_JSON_PL_COUNTRY); },
        hoopsData: function () { return this.computedCommonFunc(Const.GET_HOOPS_DATA); },
        videoTutorial: function () { return this.computedCommonFunc(Const.GET_VIDEO_TUTORIAL); },
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/plugins/fxView/index.ts
// module id = null
// module chunks = 